import { render, staticRenderFns } from "./OutputTransactionForm.vue?vue&type=template&id=d5437a6c"
import script from "./OutputTransactionForm.vue?vue&type=script&lang=js"
export * from "./OutputTransactionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports